import { compose } from 'recompose';

import CategoryEdit from './CategoryEdit';

const enhance = compose();

export default enhance(CategoryEdit);
